import { render } from "./TheModalComponent.vue?vue&type=template&id=6152f685&scoped=true"
import script from "./TheModalComponent.vue?vue&type=script&lang=js"
export * from "./TheModalComponent.vue?vue&type=script&lang=js"

import "./TheModalComponent.vue?vue&type=style&index=0&id=6152f685&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6152f685"]])

export default __exports__